'use client';

import React from 'react';
import useFetchValuationEstimate from '@th/frontend-shared/src/hooks/queries/useFetchValuationEstimate';
import { ESTIMATE_TOOLTIP_TEXT } from '@th/frontend-shared/src/constants/tooltip';
import SvgIcon from '../icons/SvgIcon';
import Tooltip from '../Tooltip';

export default function ListingEstimateSection({ listingId }) {
  const { valuationEstimate, isLoading } = useFetchValuationEstimate(listingId);

  const valuationEstimateText = valuationEstimate
    ? valuationEstimate.formatAsPrice()
    : 'not available';

  return (
    <div className="flex flex-row items-center">
      <h3>
        <span className="mr-4">Estimate:</span>
        <span>{isLoading ? 'calculating...' : valuationEstimateText}</span>
      </h3>
      <SvgIcon
        name="TbInfoCircle"
        className="ml-2 w-5 h-5 text-primary hover:cursor-pointer"
        data-tooltip-id="estimate-tooltip"
        data-tooltip-content={ESTIMATE_TOOLTIP_TEXT}
      />
      <Tooltip id="estimate-tooltip" className="max-w-xs" />
    </div>
  );
}
